angular.module('gym.components').directive('editBrivoAccessDetails', function() {
  return {
    restrict: 'E',
    template: require('templates/components/contacts/access_control/edit_brivo_access_details.html.slim'),
    scope: {
      contact: '=',
      form: '=',
      reloadContact: '&',
      addCredential: '&'
    },
    controller: ["$scope", "$stateParams", "$http", "$modal", "$window", "loadingAnimation", "flash", "AccessControl", function($scope, $stateParams, $http, $modal, $window, loadingAnimation, flash, AccessControl) {
      var brivoDetailUrl, loadActivity, loadBrivoDetail, loadCredentials;
      brivoDetailUrl = `/gyms/${$stateParams.gymId}/contacts/${$scope.contact.id}/brivo_details`;
      loadCredentials = function() {
        loadingAnimation.show();
        return $scope.contact.all('brivo_credentials').getList().then(function(data) {
          loadingAnimation.hide();
          return $scope.brivoCredentials = data;
        }, function() {
          return loadingAnimation.hide();
        });
      };
      $scope.loadBrivoDetail = loadBrivoDetail = function() {
        $scope.isBrivoDetailLoading = true;
        return $http.get(brivoDetailUrl).then(function(response) {
          $scope.isBrivoDetailLoading = false;
          $scope.brivoDetail = response.data[0];
          if ($scope.brivoDetail) {
            return $scope.brivoDetail.current_access_enabled = $scope.brivoDetail.access_enabled;
          }
        }, function() {
          return $scope.isBrivoDetailLoading = false;
        });
      };
      loadActivity = function() {
        var params;
        params = {
          'types[]': 'contact_brivo_detail_log_entry',
          count: 50
        };
        return $scope.contact.all('contact_log_entries').getList(params).then(function(data) {
          return $scope.activity = data.plain();
        });
      };
      loadActivity();
      loadBrivoDetail();
      loadCredentials();
      $scope.credentialFormats = AccessControl.all('credential_formats').getList().$object;
      $scope.saveDetails = function() {
        var url;
        url = `${brivoDetailUrl}/${$scope.brivoDetail.id}`;
        loadingAnimation.show();
        $http.put(url, {
          contact_brivo_detail: $scope.brivoDetail
        }).then(function(response) {
          flash.success = "Updated successfully";
          $scope.brivoDetail.access_enabled = response.data.access_enabled;
          $scope.brivoDetail.current_access_enabled = response.data.access_enabled;
          $scope.brivoDetail.access_override = response.data.access_override;
          $scope.brivoDetail.override_reason = response.data.override_reason;
          return loadingAnimation.hide();
        }, function() {
          return loadingAnimation.hide();
        });
        $scope.brivoDetail.override_form = false;
        return loadActivity();
      };
      $scope.onCredentialSaved = function() {
        if (!$scope.brivoDetail) {
          loadBrivoDetail();
        }
        loadCredentials();
        loadActivity();
        return $scope.reloadContact();
      };
      $scope.overrideAccess = function() {
        $scope.brivoDetail.override_form = true;
        $scope.brivoDetail.temp_access_override = $scope.brivoDetail.access_override;
        return $scope.brivoDetail.access_override = true;
      };
      $scope.cancelSaveDetails = function() {
        $scope.brivoDetail.override_form = false;
        $scope.brivoDetail.access_override = $scope.brivoDetail.temp_access_override;
        return loadBrivoDetail();
      };
      $scope.removeAccess = function() {
        $scope.brivoDetail.access_override = false;
        return $scope.saveDetails();
      };
      return $scope.removeCredential = function(credential) {
        if ($window.confirm("Are you sure?")) {
          loadingAnimation.show();
          return credential.remove().then(function() {
            loadActivity();
            return loadCredentials();
          });
        }
      };
    }]
  };
});
